module.exports = __webpack_public_path__ + "img/6101095.f91ed8cc.png";